module.exports = __webpack_public_path__ + "img/equipo_16-9_2880.192333ba.jpg";